import { TMessage } from "@/i18n/tt";

export enum RoleType {
  CHAIRPERSON = "chairperson",
  DEPUTY_CHAIRPERSON = "deputy_chairperson",
  MEMBER = "member",
  DEPUTY_MEMBER = "deputy_member",
  CEO = "ceo",
  SOLE_PROPRIETORSHIP = "sole_proprietorship",
  GENERAL_MEETING_SIGNER = "general_meeting_signer",
  OBSERVER = "observer",
  PARTICIPATOR = "participator",
  ACCOUNT_ROLE = "account_role",
}

export enum OnboardingCandidateRoleType {
  CHAIRPERSON = "chairperson",
  CEO = "ceo",
}

export function getRoleTypeLabel(roleType: RoleType | OnboardingCandidateRoleType): TMessage {
  switch (roleType) {
    case RoleType.CEO:
      return { key: "roles.ceo" };
    case RoleType.CHAIRPERSON:
      return { key: "roles.chairperson" };
    case RoleType.MEMBER:
      return { key: "roles.member" };
    case RoleType.DEPUTY_CHAIRPERSON:
      return { key: "roles.deputy_chairperson" };
    case RoleType.DEPUTY_MEMBER:
      return { key: "roles.deputy_member" };
    case RoleType.OBSERVER:
      return { key: "roles.observer" };
    case RoleType.GENERAL_MEETING_SIGNER:
      return { key: "roles.general_meeting_signer" };
    case RoleType.SOLE_PROPRIETORSHIP:
      return { key: "roles.sole_proprietorship" };
    case RoleType.PARTICIPATOR:
      return { key: "roles.participator" };
    case RoleType.ACCOUNT_ROLE:
      return { key: "roles.account_role" };
    default:
      throw Error(`Unhandled roleType: ${roleType}`);
  }
}
